<template>
  <div style=" min-height: 100vh;">
    <div style="overflow: hidden; position: relative;height:50px;width:100%;">
      <HeadNav></HeadNav>
    </div>
    <div style="overflow-y: auto;">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import HeadNav from "./HeadNav";

export default {
  components: {
    HeadNav,
  },
  data () {
    return {};
  },

};
</script>
<style lang="less" scoped>
.content {
  padding: 30px 38px;

  .kapian {
    min-height: 750px;
    position: relative;
    background: #ffffff;
    border-radius: 20px;
    padding: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/index.vue